import React from 'react';
import {Link} from "react-router-dom";
import {getTranslation} from "../../translations/translationUtils";

const ExcursionEntryTitle = ({buttonIsLink, excursionLink, excursionName}) => {
    return (
        <Link className={`text-primary text-2xl uppercase ${buttonIsLink ? "text-underline" : "text-no-underline"}`} to={excursionLink}>
            {getTranslation(excursionName)}
        </Link>
    );
};

export default ExcursionEntryTitle;